import type { FC } from 'react';

const ChevronUpIcon: FC = () => {
  return (
    <svg className="h-6 w-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
    </svg>
  );
};

export default ChevronUpIcon;
